import React from "react";

export default function TerritoireTab() {
  return (
    <div className="diagoeau-panel">
      <h3>À construire prochainement</h3>
    </div>
  );
}